<script lang="ts">
    import type { TopInfo } from '@shared/types/types';

    interface Props {
        infos: TopInfo[] | undefined;
    }

    let { infos }: Props = $props();
</script>

{#if infos?.length}
    <dl class="reptile-top-info oc-copy-75 oc-py-50">
        {#each infos.slice(0, 3) as info (info)}
            <div class="reptile-top-info__item">
                <dd class="reptile-top-info__value oc-copy--bold">{info.value}</dd>
                <dt class="reptile-top-info__label">{info.label}</dt>
            </div>
        {/each}
    </dl>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    /**
 *
 *
 *
 */
    .reptile-top-info {
        border-top: tokens.$oc-semantic-border-width-100 solid tokens.$oc-semantic-color-disabled-background;
        border-bottom: tokens.$oc-semantic-border-width-100 solid tokens.$oc-semantic-color-disabled-background;
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-25;

        &__item {
            @include mixins.ellipsis(nowrap);
        }

        &__label,
        &__value {
            display: inline;
        }
    }
</style>
